var Observable_1;
import { __awaiter, __decorate, __metadata } from "tslib";
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { listenCompose } from '@smoovy/event';
export var ObservableEvent;
(function (ObservableEvent) {
    ObservableEvent["UPDATE"] = "update";
    ObservableEvent["VISIBILITY_CHANGED"] = "visibility-changed";
})(ObservableEvent || (ObservableEvent = {}));
let Observable = Observable_1 = class Observable extends LitElement {
    constructor() {
        super(...arguments);
        this._visible = false;
        this.locked = false;
        this.rootName = 'default';
        this.once = false;
    }
    connectedCallback() {
        const _super = Object.create(null, {
            connectedCallback: { get: () => super.connectedCallback }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super.connectedCallback.call(this);
            setTimeout(() => {
                if (this.rootName) {
                    const selector = `djx-observable-root[name="${this.rootName}"]`;
                    this.root = document.querySelector(selector);
                }
                if (!this.root) {
                    throw new Error(`observable root "${this.rootName}" not found.`);
                }
                this.root.ready.then(() => {
                    this.observable = this.root.observe(this);
                    this.unlisten = listenCompose(this.observable.onVisibilityChanged((visible) => {
                        this.handleVisibilityChange(visible);
                    }), this.observable.onUpdate(() => this.handleUpdate()));
                });
            });
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.observable) {
            this.root.unobserve(this.observable);
        }
        if (this.unlisten) {
            this.unlisten();
            delete this.unlisten;
        }
    }
    recalc() {
        if (this.observable) {
            this.observable.update();
        }
    }
    handleUpdate() {
        if (this.observable) {
            this.dispatchEvent(new CustomEvent(ObservableEvent.UPDATE, {
                detail: {
                    offset: this.observable.offset,
                    bounds: this.observable.bounds
                }
            }));
        }
    }
    handleVisibilityChange(visible) {
        if (this.locked) {
            return;
        }
        const wasVisible = this._visible;
        if (wasVisible !== visible) {
            this._visible = visible;
            if (this._visible) {
                this.classList.add(Observable_1.visibleClass);
            }
            else {
                this.classList.remove(Observable_1.visibleClass);
            }
            this.dispatchEvent(new CustomEvent(ObservableEvent.VISIBILITY_CHANGED, {
                detail: {
                    visible: this._visible
                }
            }));
            if (this.once) {
                this.locked = true;
            }
        }
    }
    render() {
        return html `<slot></slot>`;
    }
};
Observable.styles = css `:host { display: block; }`;
Observable.visibleClass = 'djx--is-visible';
__decorate([
    property({ type: String, attribute: 'root' }),
    __metadata("design:type", Object)
], Observable.prototype, "rootName", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], Observable.prototype, "once", void 0);
Observable = Observable_1 = __decorate([
    customElement(`djx-observable`)
], Observable);
export { Observable };
//# sourceMappingURL=observable.js.map